import React, { useState, useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage } from "../shared/const.prop";
import { AuthContext } from "../contexts/AuthContext";

const ChangePassword = () => {
  const [isShow, setIsShow] = useState(false);
  const [newPass, setNewPass] = useState(false);
  const [confirmPass, setConfirmPass] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [formValue, setFormValue] = useState({
    old: "",
    newPass: "",
    confirmPass: "",
  });
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);

  const handleChange = (e) => {
    setErrMsg("");
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleSubmit = () => {
    if (formValue?.old.trim().length < 4) {
      setErrMsg("Old Password must be atleast 4 characters long");
    } else if (formValue?.newPass.trim().length < 4) {
      setErrMsg("New Password must be atleast 4 characters long");
    } else if (formValue?.newPass !== formValue?.confirmPass) {
      setErrMsg("Passwords not matching");
    } else {
      changePasswordHandler();
    }
  };

  const changePasswordHandler = async () => {
    let payload = {
      oldPassword: btoa(formValue?.old),
      newPassword: btoa(formValue?.newPass),
    };
    try {
      const submitDetails = await axiosHttp.post("change-password", payload);
      if (submitDetails.status === 202) {
        appContext.updateModalState();
        authContext.logout();
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(error),
        type: "error",
      });
    }
  };

  return (
    <div>
      <div className="modal-body">
        {errMsg !== "" && <p className="error">{errMsg}</p>}
        <div className="mb-3 mt-4">
          <label htmlFor="#" className="sign-label">
            Current Password
          </label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text sign-icon" id="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3123 1.66814C12.7457 1.66814 14.7273 3.64981 14.7273 6.08564L14.7272 7.39947C16.2066 7.91432 17.2708 9.32265 17.2708 10.9755V14.5496C17.2708 16.6371 15.5733 18.3346 13.4858 18.3346H7.11825C5.03075 18.3346 3.33325 16.6371 3.33325 14.5496V10.9755C3.33325 9.32296 4.39702 7.91485 5.87592 7.39976L5.8765 6.08564C5.8815 4.88564 6.34567 3.77814 7.18317 2.94814C8.0215 2.11731 9.12817 1.63647 10.3123 1.66814ZM13.4858 8.44047H7.11825C5.71992 8.44047 4.58325 9.57714 4.58325 10.9755V14.5496C4.58325 15.948 5.71992 17.0846 7.11825 17.0846H13.4858C14.8833 17.0846 16.0208 15.948 16.0208 14.5496V10.9755C16.0208 9.57714 14.8833 8.44047 13.4858 8.44047ZM10.3018 11.212C10.6468 11.212 10.9268 11.492 10.9268 11.837V13.6878C10.9268 14.0328 10.6468 14.3128 10.3018 14.3128C9.95684 14.3128 9.67684 14.0328 9.67684 13.6878V11.837C9.67684 11.492 9.95684 11.212 10.3018 11.212ZM10.3098 2.91814H10.2965C9.45233 2.91814 8.6615 3.24314 8.064 3.83564C7.46234 4.43064 7.12984 5.22481 7.1265 6.07147L7.12575 7.19H13.4766L13.4773 6.08564C13.4773 4.33897 12.0565 2.91814 10.3098 2.91814Z"
                    fill="black"
                    fillOpacity="0.6"
                  />
                </svg>
              </span>
            </div>
            <input
              type={isShow ? "text" : "password"}
              className="form-control sign-form"
              placeholder=""
              aria-describedby=""
              name="old"
              onChange={handleChange}
              value={formValue?.old}
            />
            <div className="input-group-append">
              <span
                role="presentation"
                onClick={() => setIsShow((prev) => !!!prev)}
                className="input-group-text sign-icon"
              >
                {!isShow && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_23_60)">
                      <path
                        d="M6.89331 4.78272L8.8974 6.78681L8.90694 6.68184C8.90694 5.62888 8.05124 4.77318 6.99829 4.77318L6.89331 4.78272Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M6.99843 3.50074C8.75439 3.50074 10.1795 4.92588 10.1795 6.68184C10.1795 7.09221 10.0968 7.48348 9.95369 7.84293L11.8146 9.70388C12.7753 8.90224 13.5324 7.86521 14 6.68184C12.8962 3.88885 10.1827 1.9102 6.99846 1.9102C6.10774 1.9102 5.25523 2.06925 4.46313 2.35555L5.83737 3.72659C6.19679 3.58663 6.58807 3.50074 6.99843 3.50074Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M0.636209 1.7671L2.08679 3.21768L2.37628 3.50717C1.32652 4.3279 0.496251 5.41902 0 6.6819C1.10067 9.47489 3.81731 11.4535 6.99842 11.4535C7.98457 11.4535 8.92616 11.2627 9.78825 10.9159L10.0587 11.1863L11.9132 13.0441L12.7244 12.2361L1.44739 0.955925L0.636209 1.7671ZM4.15452 5.28222L5.13748 6.26518C5.10885 6.40198 5.08976 6.53875 5.08976 6.6819C5.08976 7.73485 5.94547 8.59055 6.99842 8.59055C7.14157 8.59055 7.27837 8.57147 7.41197 8.54284L8.39493 9.52579C7.97183 9.73575 7.50105 9.863 6.99842 9.863C5.24245 9.863 3.81731 8.43786 3.81731 6.6819C3.81731 6.17929 3.94457 5.70848 4.15452 5.28222Z"
                        fill="#ABABAB"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_23_60">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
                {isShow && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                  >
                    <path
                      d="M15.4567 8.80458C15.3979 8.72029 13.9961 6.71925 12.0616 5.35146C11.0586 4.641 9.79353 4.25 8.50011 4.25C7.20741 4.25 5.94232 4.641 4.9372 5.35146C3.00274 6.71925 1.60236 8.72029 1.54357 8.80458C1.46116 8.92323 1.41699 9.06423 1.41699 9.20869C1.41699 9.35315 1.46116 9.49415 1.54357 9.61279C1.60236 9.69708 3.00274 11.6981 4.9372 13.0659C5.94232 13.7757 7.20741 14.1667 8.50011 14.1667C9.79353 14.1667 11.0586 13.7757 12.0616 13.0652C13.9961 11.6974 15.3979 9.69637 15.4567 9.61208C15.5393 9.49366 15.5836 9.35274 15.5836 9.20833C15.5836 9.06393 15.5393 8.923 15.4567 8.80458ZM8.50011 11.6875C7.1302 11.6875 6.02095 10.5754 6.02095 9.20833C6.02095 7.83842 7.1302 6.72917 8.50011 6.72917C9.8672 6.72917 10.9793 7.83842 10.9793 9.20833C10.9793 10.5754 9.8672 11.6875 8.50011 11.6875ZM9.91678 9.20833C9.91678 9.98892 9.2807 10.625 8.50011 10.625C8.21992 10.625 7.94603 10.5419 7.71306 10.3862C7.48009 10.2306 7.29851 10.0093 7.19129 9.75047C7.08406 9.49161 7.05601 9.20676 7.11067 8.93196C7.16533 8.65715 7.30026 8.40472 7.49838 8.2066C7.6965 8.00847 7.94893 7.87355 8.22374 7.81889C8.49854 7.76423 8.78339 7.79228 9.04225 7.8995C9.30111 8.00673 9.52236 8.18831 9.67803 8.42128C9.8337 8.65425 9.91678 8.92814 9.91678 9.20833Z"
                      fill="#ABABAB"
                    />
                  </svg>
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="mb-3 mt-4">
          <label htmlFor="#" className="sign-label">
            New Password
          </label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text sign-icon" id="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3123 1.66814C12.7457 1.66814 14.7273 3.64981 14.7273 6.08564L14.7272 7.39947C16.2066 7.91432 17.2708 9.32265 17.2708 10.9755V14.5496C17.2708 16.6371 15.5733 18.3346 13.4858 18.3346H7.11825C5.03075 18.3346 3.33325 16.6371 3.33325 14.5496V10.9755C3.33325 9.32296 4.39702 7.91485 5.87592 7.39976L5.8765 6.08564C5.8815 4.88564 6.34567 3.77814 7.18317 2.94814C8.0215 2.11731 9.12817 1.63647 10.3123 1.66814ZM13.4858 8.44047H7.11825C5.71992 8.44047 4.58325 9.57714 4.58325 10.9755V14.5496C4.58325 15.948 5.71992 17.0846 7.11825 17.0846H13.4858C14.8833 17.0846 16.0208 15.948 16.0208 14.5496V10.9755C16.0208 9.57714 14.8833 8.44047 13.4858 8.44047ZM10.3018 11.212C10.6468 11.212 10.9268 11.492 10.9268 11.837V13.6878C10.9268 14.0328 10.6468 14.3128 10.3018 14.3128C9.95684 14.3128 9.67684 14.0328 9.67684 13.6878V11.837C9.67684 11.492 9.95684 11.212 10.3018 11.212ZM10.3098 2.91814H10.2965C9.45233 2.91814 8.6615 3.24314 8.064 3.83564C7.46234 4.43064 7.12984 5.22481 7.1265 6.07147L7.12575 7.19H13.4766L13.4773 6.08564C13.4773 4.33897 12.0565 2.91814 10.3098 2.91814Z"
                    fill="black"
                    fillOpacity="0.6"
                  />
                </svg>
              </span>
            </div>
            <input
              type={newPass ? "text" : "password"}
              className="form-control sign-form"
              placeholder=""
              aria-describedby=""
              name="newPass"
              onChange={handleChange}
              value={formValue?.newPass}
            />
            <div className="input-group-append">
              <span
                role="presentation"
                onClick={() => setNewPass((prev) => !!!prev)}
                className="input-group-text sign-icon"
              >
                {!newPass && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_23_60)">
                      <path
                        d="M6.89331 4.78272L8.8974 6.78681L8.90694 6.68184C8.90694 5.62888 8.05124 4.77318 6.99829 4.77318L6.89331 4.78272Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M6.99843 3.50074C8.75439 3.50074 10.1795 4.92588 10.1795 6.68184C10.1795 7.09221 10.0968 7.48348 9.95369 7.84293L11.8146 9.70388C12.7753 8.90224 13.5324 7.86521 14 6.68184C12.8962 3.88885 10.1827 1.9102 6.99846 1.9102C6.10774 1.9102 5.25523 2.06925 4.46313 2.35555L5.83737 3.72659C6.19679 3.58663 6.58807 3.50074 6.99843 3.50074Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M0.636209 1.7671L2.08679 3.21768L2.37628 3.50717C1.32652 4.3279 0.496251 5.41902 0 6.6819C1.10067 9.47489 3.81731 11.4535 6.99842 11.4535C7.98457 11.4535 8.92616 11.2627 9.78825 10.9159L10.0587 11.1863L11.9132 13.0441L12.7244 12.2361L1.44739 0.955925L0.636209 1.7671ZM4.15452 5.28222L5.13748 6.26518C5.10885 6.40198 5.08976 6.53875 5.08976 6.6819C5.08976 7.73485 5.94547 8.59055 6.99842 8.59055C7.14157 8.59055 7.27837 8.57147 7.41197 8.54284L8.39493 9.52579C7.97183 9.73575 7.50105 9.863 6.99842 9.863C5.24245 9.863 3.81731 8.43786 3.81731 6.6819C3.81731 6.17929 3.94457 5.70848 4.15452 5.28222Z"
                        fill="#ABABAB"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_23_60">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
                {newPass && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                  >
                    <path
                      d="M15.4567 8.80458C15.3979 8.72029 13.9961 6.71925 12.0616 5.35146C11.0586 4.641 9.79353 4.25 8.50011 4.25C7.20741 4.25 5.94232 4.641 4.9372 5.35146C3.00274 6.71925 1.60236 8.72029 1.54357 8.80458C1.46116 8.92323 1.41699 9.06423 1.41699 9.20869C1.41699 9.35315 1.46116 9.49415 1.54357 9.61279C1.60236 9.69708 3.00274 11.6981 4.9372 13.0659C5.94232 13.7757 7.20741 14.1667 8.50011 14.1667C9.79353 14.1667 11.0586 13.7757 12.0616 13.0652C13.9961 11.6974 15.3979 9.69637 15.4567 9.61208C15.5393 9.49366 15.5836 9.35274 15.5836 9.20833C15.5836 9.06393 15.5393 8.923 15.4567 8.80458ZM8.50011 11.6875C7.1302 11.6875 6.02095 10.5754 6.02095 9.20833C6.02095 7.83842 7.1302 6.72917 8.50011 6.72917C9.8672 6.72917 10.9793 7.83842 10.9793 9.20833C10.9793 10.5754 9.8672 11.6875 8.50011 11.6875ZM9.91678 9.20833C9.91678 9.98892 9.2807 10.625 8.50011 10.625C8.21992 10.625 7.94603 10.5419 7.71306 10.3862C7.48009 10.2306 7.29851 10.0093 7.19129 9.75047C7.08406 9.49161 7.05601 9.20676 7.11067 8.93196C7.16533 8.65715 7.30026 8.40472 7.49838 8.2066C7.6965 8.00847 7.94893 7.87355 8.22374 7.81889C8.49854 7.76423 8.78339 7.79228 9.04225 7.8995C9.30111 8.00673 9.52236 8.18831 9.67803 8.42128C9.8337 8.65425 9.91678 8.92814 9.91678 9.20833Z"
                      fill="#ABABAB"
                    />
                  </svg>
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="mb-3 mt-4">
          <label htmlFor="#" className="sign-label">
            Confirm Password
          </label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text sign-icon" id="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3123 1.66814C12.7457 1.66814 14.7273 3.64981 14.7273 6.08564L14.7272 7.39947C16.2066 7.91432 17.2708 9.32265 17.2708 10.9755V14.5496C17.2708 16.6371 15.5733 18.3346 13.4858 18.3346H7.11825C5.03075 18.3346 3.33325 16.6371 3.33325 14.5496V10.9755C3.33325 9.32296 4.39702 7.91485 5.87592 7.39976L5.8765 6.08564C5.8815 4.88564 6.34567 3.77814 7.18317 2.94814C8.0215 2.11731 9.12817 1.63647 10.3123 1.66814ZM13.4858 8.44047H7.11825C5.71992 8.44047 4.58325 9.57714 4.58325 10.9755V14.5496C4.58325 15.948 5.71992 17.0846 7.11825 17.0846H13.4858C14.8833 17.0846 16.0208 15.948 16.0208 14.5496V10.9755C16.0208 9.57714 14.8833 8.44047 13.4858 8.44047ZM10.3018 11.212C10.6468 11.212 10.9268 11.492 10.9268 11.837V13.6878C10.9268 14.0328 10.6468 14.3128 10.3018 14.3128C9.95684 14.3128 9.67684 14.0328 9.67684 13.6878V11.837C9.67684 11.492 9.95684 11.212 10.3018 11.212ZM10.3098 2.91814H10.2965C9.45233 2.91814 8.6615 3.24314 8.064 3.83564C7.46234 4.43064 7.12984 5.22481 7.1265 6.07147L7.12575 7.19H13.4766L13.4773 6.08564C13.4773 4.33897 12.0565 2.91814 10.3098 2.91814Z"
                    fill="black"
                    fillOpacity="0.6"
                  />
                </svg>
              </span>
            </div>
            <input
              type={confirmPass ? "text" : "password"}
              name="confirmPass"
              onChange={handleChange}
              value={formValue?.confirmPass}
              className="form-control sign-form"
              placeholder=""
              aria-describedby=""
            />
            <div className="input-group-append">
              <span
                role="presentation"
                onClick={() => setConfirmPass((prev) => !!!prev)}
                className="input-group-text sign-icon"
              >
                {!confirmPass && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_23_60)">
                      <path
                        d="M6.89331 4.78272L8.8974 6.78681L8.90694 6.68184C8.90694 5.62888 8.05124 4.77318 6.99829 4.77318L6.89331 4.78272Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M6.99843 3.50074C8.75439 3.50074 10.1795 4.92588 10.1795 6.68184C10.1795 7.09221 10.0968 7.48348 9.95369 7.84293L11.8146 9.70388C12.7753 8.90224 13.5324 7.86521 14 6.68184C12.8962 3.88885 10.1827 1.9102 6.99846 1.9102C6.10774 1.9102 5.25523 2.06925 4.46313 2.35555L5.83737 3.72659C6.19679 3.58663 6.58807 3.50074 6.99843 3.50074Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M0.636209 1.7671L2.08679 3.21768L2.37628 3.50717C1.32652 4.3279 0.496251 5.41902 0 6.6819C1.10067 9.47489 3.81731 11.4535 6.99842 11.4535C7.98457 11.4535 8.92616 11.2627 9.78825 10.9159L10.0587 11.1863L11.9132 13.0441L12.7244 12.2361L1.44739 0.955925L0.636209 1.7671ZM4.15452 5.28222L5.13748 6.26518C5.10885 6.40198 5.08976 6.53875 5.08976 6.6819C5.08976 7.73485 5.94547 8.59055 6.99842 8.59055C7.14157 8.59055 7.27837 8.57147 7.41197 8.54284L8.39493 9.52579C7.97183 9.73575 7.50105 9.863 6.99842 9.863C5.24245 9.863 3.81731 8.43786 3.81731 6.6819C3.81731 6.17929 3.94457 5.70848 4.15452 5.28222Z"
                        fill="#ABABAB"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_23_60">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
                {confirmPass && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                  >
                    <path
                      d="M15.4567 8.80458C15.3979 8.72029 13.9961 6.71925 12.0616 5.35146C11.0586 4.641 9.79353 4.25 8.50011 4.25C7.20741 4.25 5.94232 4.641 4.9372 5.35146C3.00274 6.71925 1.60236 8.72029 1.54357 8.80458C1.46116 8.92323 1.41699 9.06423 1.41699 9.20869C1.41699 9.35315 1.46116 9.49415 1.54357 9.61279C1.60236 9.69708 3.00274 11.6981 4.9372 13.0659C5.94232 13.7757 7.20741 14.1667 8.50011 14.1667C9.79353 14.1667 11.0586 13.7757 12.0616 13.0652C13.9961 11.6974 15.3979 9.69637 15.4567 9.61208C15.5393 9.49366 15.5836 9.35274 15.5836 9.20833C15.5836 9.06393 15.5393 8.923 15.4567 8.80458ZM8.50011 11.6875C7.1302 11.6875 6.02095 10.5754 6.02095 9.20833C6.02095 7.83842 7.1302 6.72917 8.50011 6.72917C9.8672 6.72917 10.9793 7.83842 10.9793 9.20833C10.9793 10.5754 9.8672 11.6875 8.50011 11.6875ZM9.91678 9.20833C9.91678 9.98892 9.2807 10.625 8.50011 10.625C8.21992 10.625 7.94603 10.5419 7.71306 10.3862C7.48009 10.2306 7.29851 10.0093 7.19129 9.75047C7.08406 9.49161 7.05601 9.20676 7.11067 8.93196C7.16533 8.65715 7.30026 8.40472 7.49838 8.2066C7.6965 8.00847 7.94893 7.87355 8.22374 7.81889C8.49854 7.76423 8.78339 7.79228 9.04225 7.8995C9.30111 8.00673 9.52236 8.18831 9.67803 8.42128C9.8337 8.65425 9.91678 8.92814 9.91678 9.20833Z"
                      fill="#ABABAB"
                    />
                  </svg>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer mr-3">
        <div className="ml-auto mb-5">
          <div className="row">
            <div className=" text-center">
              <button
                type="button"
                className="btn btn-outline-primary prime-btn mr-1"
                onClick={() => appContext.updateModalState()}
              >
                Cancel
              </button>
            </div>
            <div className="">
              <button
                type="button"
                className="btn btn-primary prime-btn"
                data-dismiss="modal"
                onClick={handleSubmit}
                disabled={
                  formValue?.old === "" ||
                  formValue?.newPass === "" ||
                  formValue?.confirmPass === ""
                }
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
